import styled from 'styled-components';

import DotExplanation from '@/components/ContextPrinter/DotExplanation';
import StringUtil from '@/utils/StringUtil';
import { FontStyle } from '@/utils/StyleUtil';

interface Props {
    associationNumber: string;
    advConfirmationCode: string;
    advConfirmationEffectiveDateStartedAt: Date;
    advConfirmationEffectiveDateExpiredAt: Date;
}

export default function ConfirmationEffectiveDatePart({
    associationNumber,
    advConfirmationCode,
    advConfirmationEffectiveDateStartedAt,
    advConfirmationEffectiveDateExpiredAt,
}: Props) {
    return (
        <Container>
            {associationNumber && (
                <DotExplanation
                    contents={[{ parent: `협회등록번호 ${associationNumber}` }]}
                    parentStyle={FontStyle(12, 20, '400', '#acacac')}
                    containerStyle={{ padding: 0 }}
                />
            )}
            {advConfirmationEffectiveDateStartedAt && advConfirmationEffectiveDateExpiredAt && (
                <DotExplanation
                    contents={[
                        {
                            parent: `${advConfirmationCode}\n(${StringUtil.displayedDateAt(
                                advConfirmationEffectiveDateStartedAt,
                            )}~${StringUtil.displayedDateAt(advConfirmationEffectiveDateExpiredAt)})`,
                        },
                    ]}
                    parentStyle={FontStyle(12, 20, '400', '#acacac')}
                    containerStyle={{ padding: 0 }}
                />
            )}
        </Container>
    );
}

const Container = styled.div``;
